module.exports = __webpack_public_path__ + "static/img/realease-01.1c871fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-01.png
// module id = 141
// module chunks = 0